<template>
  <div>
    <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Documentos</h1>
    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :disable-search="true"
      :route="'/patients/documents/' + patient.id"
      no-data-label="Nenhum documento cadastrado"
      no-result-label="Nenhum documento encontrado"
    >
      <template #table.cell.content.actions="{ value, row }">
        <div class="inline-grid grid-cols-1 gap-4 ">
          <a :href="`/patients/documents/download/` + row.id" target="_blank"><font-awesome-icon icon="fa-eye" class="text-green-500 text-lg cursor-pointer" /></a>
        </div>
      </template>
      <template #grid.content.body.actions="{ value, row }">
        <div class="inline-grid grid-cols-1 gap-4 ">
          <a :href="`/patients/documents/download/` + row.id" target="_blank"><font-awesome-icon icon="fa-eye" class="text-green-500 text-lg cursor-pointer" /></a>
        </div>
      </template>

      <template #after.reload-button>
        <button v-if="user.role == 2" class="flex items-end font-roboto font-medium btn-primary uppercase" @click.prevent="openModalEdit({})" :disabled="Array.isArray(this.appointments()) && !this.appointments().length" :title="Array.isArray(this.appointments()) && !this.appointments().length ? 'Nenhum agendamento' : ''">
          <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block"> Adicionar Documento</span>
        </button>
        <div v-if="Array.isArray(this.appointments()) && !this.appointments().length" class="block w-full text-center lg:hidden">Nenhum agendamento</div>
      </template>
    </data-table>
  </div>
  <modal-edit-steps ref="modalEdit" :steps="stepItems" :modal-align="this.appointmentOpen() ? 'left' : 'center'" :modal-backdrop="!this.appointmentOpen()">
    <template #content.upload="{item}">
      <select-input v-model="item.appointment_id" :error="item.errors.appointment_id" class="lg:pr-6 w-full lg:w-1/2" label="Atendimento vinculado">
        <option :value="null" disabled class="hidden invisible">Atendimento vinculado</option>
        <option v-for="(value, name, index) in this.appointments()" :key="name" :value="name">{{ this.$filters.formatDateTime(value, 'dd/MM/yyyy - HH:mm') }}</option>
      </select-input>
      <div class="w-full mt-6">
        Faça o upload do documento:
      </div>
      <file-input v-model="item.file" :error="item.errors.file" class="mt-6 w-full" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf,application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation" />
    </template>
    <template #content.success>
      <div class="w-full text-center">
        <font-awesome-icon icon="fa-regular fa-circle-check" class="text-green-600 text-7xl mr-0 lg:mr-2" />
      </div>
      <div class="w-full text-center mt-5 uppercase">
        O documento foi enviado para o paciente
      </div>
    </template>
  </modal-edit-steps>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import format from 'date-fns/format';
import LoadingButton from '@/Shared/Components/LoadingButton'
import ModalEdit from '@/Shared/Modal/ModalEdit'
import ModalEditSteps from '@/Shared/Modal/ModalEditSteps'
import DataTable from '@/Shared/Components/DataTable'
import SwitchInput from '@/Shared/Fields/SwitchInput'
import TextInput from '@/Shared/Fields/TextInput'
import VueSelectInput from '@/Shared/Fields/VueSelectInput'
import DateTimeInput from '@/Shared/Fields/DateTimeInput'
import TextareaInput from '@/Shared/Fields/TextareaInput'
import FileInput from '@/Shared/Fields/FileInput'
import SelectInput from '@/Shared/Fields/SelectInput'
import TimeInput from '@/Shared/Fields/TimeInput'
import DateInput from '@/Shared/Fields/DateInput'

export default {
  inject: ['patient', 'professionals', 'professional_addresses', 'appointments', 'loadOptions', 'appointmentOpen'],
  components: {
    LoadingButton,
    ModalEdit,
    ModalEditSteps,
    DataTable,
    SwitchInput,
    TextInput,
    VueSelectInput,
    DateTimeInput,
    TextareaInput,
    FileInput,
    SelectInput,
    TimeInput,
    DateInput,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  data() {
    return {
      loadTable: true,
      stepItems: [
        {
          idStep: 'upload',
          title: 'Envie o documento',
          submitCallback: (item, callback) => {
            let success = false;
            item.post(`/patients/documents/` + this.patient.id, {
                forceFormData: true,
                onFinish: () => {
                  let success = false;
                  if(!Object.keys(item.errors).length) {
                      success = true;
                      this.reloadTable();
                      this.loadOptions();
                  }
                  callback(success);
                }
            });
            return success;
          }
        },
        {
          idStep: 'success',
          title: 'Documento enviado para o paciente',
        },
      ],
      columns: [
        {
          uniqid: 'document_date_start',
          label: 'Atendimento',
          field: 'appointments.date_start',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => format(new Date(row.appointment.date_start), 'dd/MM/yyy - HH:mm'),
        },
        {
          uniqid: 'document_created_at',
          label: 'Data do documento',
          field: 'created_at',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => format(new Date(row.created_at), 'dd/MM/yyy HH:mm'),
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        appointment_id: item.appointment_id,
        file: item.file,
        professional: item.professional ?? null,
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
  },
}
</script>